
import React, { useEffect, useState } from 'react';
import SectionTitle from '../ConsultancyElements/SectionTitle';
import FaqService from '../../services/FaqService';
import { useNavigate } from 'react-router-dom';

const Accordion = () => {
    const navigate = useNavigate();
    const [faqList, setFaqList] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getFaqs();
    }, []);

    const getFaqs = async () => {
        try {
            setLoading(true);
            const response = await FaqService.getFaqList();
            console.log("respnse faq is", response)
            const activeFaqs = (response?.data || []).filter(item => item?.isPublished === true);
            setFaqList(activeFaqs);
        } catch (error) {
            console.error("Error fetching FAQs:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="accordion-section pb-0" style={{ backgroundImage: `url(images/background/17.jpg)` }}>
            <div className="container">
                <div className="inner-column">
                    <SectionTitle
                        title='Ask What You Want To Know'
                        header='Frequently Asked Questions'
                    />

                    <div className="row clearfix">
                        {/* */}
                        <div className="col-lg-5 col-md-5 col-sm-12 faq-image-container">
                            <div className="care-imagebox">
                                <img src="images/resource/care.png" alt="img" />
                            </div>
                        </div>

                        {/* */}
                        <div className="col-lg-7 col-md-7 col-sm-12">
                            <div className="accordion accordion-default" id="accordionFaq">
                                {loading ? (
                                    <p>Loading questions...</p>
                                ) : faqList.length > 0 ? (
                                    faqList.map((item, index) => (
                                        <div className="accordion-item" key={item.id}>
                                            <h2 className="accordion-header" id={`heading${item.id}`}>
                                                <button 
                                                    className={`accordion-button ${index === 0 ? '' : 'collapsed'}`} 
                                                    type="button" 
                                                    data-bs-toggle="collapse" 
                                                    data-bs-target={`#collapse${item.id}`} 
                                                    aria-expanded={index === 0 ? "true" : "false"}
                                                    aria-controls={`collapse${item.id}`}
                                                >
                                                    {item.question}
                                                    <span className="accordion-tab-icon">
                                                        <i className="open-icon bi bi-plus"></i>
                                                        <i className="close-icon bi bi-dash"></i>
                                                    </span>
                                                </button>
                                            </h2>
                                            <div 
                                                id={`collapse${item.id}`} 
                                                className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`} 
                                                aria-labelledby={`heading${item.id}`}
                                                data-bs-parent="#accordionFaq"
                                            >
                                                <div className="accordion-body">
                                                    {item.answer}
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <p>No active questions found.</p>
                                )}
                            </div>

                            <div className="more-query">
                                <p>Still Have More Questions?</p>
                                <h6>Contact Our <a onClick={() => navigate('/contact#Contact-form')} style={{color: "red"}}>Expert Support Team</a></h6>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
                </section>
  )
}

export default Accordion;